module.exports = __webpack_public_path__ + "img/467.04b600f9.jpg";